export var tripDetailsTokens = {
    ink: "#0e0e0e",
    paper: "#f5f2eb",
    cream: "#faf8f3",
    rust: "#c0401a",
    rustLight: "#f4ede8",
    olive: "#4a5240",
    sand: "#d9c8a9",
    muted: "#7a7368",
    border: "#e2ddd4",
    white: "#ffffff",
    green: "#2e6e4e",
    greenBg: "#eef5f0",
    amber: "#b87c1e",
    amberBg: "#fdf5e6",
};
